import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../Axois/Axois';
import { Button, ProgressBar } from 'react-bootstrap';
import DonationModal from '../../../component/homecomponent/Donationmodal';

const Profile1 = () => {
   const [showModal, setShowModal] = useState(false);
  const { id } = useParams();
  const [entrepreneur, setEntrepreneur] = useState(null);
  const [loading, setLoading] = useState(true);

useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when page loads

    const fetchData = async () => {
        try {
            const res = await axiosInstance.get(`/show/borrower/${id}`);
            setEntrepreneur(res.data.borrower);
        } catch (error) {
            console.error("Error fetching entrepreneur:", error);
        } finally {
            setLoading(false);
        }
    };

    fetchData();
}, [id]);

  if (loading) return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );

  if (!entrepreneur) return <p className="text-center mt-5">No entrepreneur data found</p>;

  // Calculate funding progress
  const fundedAmount = entrepreneur.loan - (entrepreneur.remain_loan || entrepreneur.loan);
  const progressPercentage = (fundedAmount / entrepreneur.loan) * 100;

  return (
    <div className="container py-5" style={{ marginTop: '100px' }}>
      <div className="row">
        {/* Left Column - Image */}
        <div className="col-lg-5 mb-4 mb-lg-0">
          <div className="card border-0 shadow-sm h-100">
            <img
              src={entrepreneur.image || "https://via.placeholder.com/500x500?text=No+Image"}
              alt={entrepreneur.name}
              className="card-img-top img-fluid rounded-top"
              style={{ objectFit: 'cover', height: '400px' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/500x500?text=No+Image";
              }}
            />
            <div className="card-body text-center">
              <h3 className="card-title">{entrepreneur.title} {entrepreneur.name}</h3>
              <p className="text-muted">
                <i className="bi bi-geo-alt-fill me-2"></i>
                {entrepreneur.address}
              </p>
            </div>
          </div>
        </div>

        {/* Right Column - Details */}
        <div className="col-lg-7">
          <div className="card border-0 shadow-sm h-100">
            <div className="card-body">
              {/* Funding Progress */}
              <div className="mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <h5 className="mb-0">Funding Progress</h5>
                  <span className="text-primary fw-bold">
                    ${fundedAmount.toLocaleString()} raised of ${entrepreneur.loan.toLocaleString()}
                  </span>
                </div>
                <ProgressBar now={progressPercentage} variant="success" className="mb-3" style={{ height: '10px' }} />
                <div className="d-flex justify-content-between small text-muted">
                  <span>{Math.round(progressPercentage)}% funded</span>
                  <span>{entrepreneur.loan_length} month loan</span>
                </div>
              </div>

              {/* Loan Details */}
              <div className="mb-4 p-3 bg-light rounded">
                <h5 className="mb-3">
                  <i className="bi bi-cash-stack me-2"></i>
                  Loan Details
                </h5>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <p className="mb-1"><strong>Loan Amount:</strong></p>
                    <p>${entrepreneur.loan}</p>
                  </div>
                  <div className="col-md-6 mb-2">
                    <p className="mb-1"><strong>Monthly Payment:</strong></p>
                    <p>${entrepreneur.per_month}</p>
                  </div>
                  <div className="col-md-6 mb-2">
                    <p className="mb-1"><strong>Repayment Schedule:</strong></p>
                    <p>{entrepreneur.repayment_schedule}</p>
                  </div>
                  <div className="col-md-6 mb-2">
                    <p className="mb-1"><strong>Loan Term:</strong></p>
                    <p>{entrepreneur.loan_length} months</p>
                  </div>
                </div>
              </div>

              {/* About Section */}
              <div className="mb-4">
                <h5 className="mb-3">
                  <i className="bi bi-person-lines-fill me-2"></i>
                  About {entrepreneur.name.split(' ')[0]}
                </h5>
                <p className="text-muted">{entrepreneur.about}</p>
              </div>

              {/* Business Section */}
              <div className="mb-4">
                <h5 className="mb-3">
                  <i className="bi bi-briefcase-fill me-2"></i>
                  Business Details
                </h5>
                <div dangerouslySetInnerHTML={{ __html: entrepreneur.business }} className="text-muted" />
              </div>

              {/* Contact CSP */}
              {entrepreneur.csp && (
                <div className="mt-4 p-3 bg-light rounded">
                  <h5 className="mb-3">
                    <i className="bi bi-person-badge-fill me-2"></i>
                    Community Support Person
                  </h5>
                  <p><strong>Name:</strong> {entrepreneur.csp.name}</p>
                  <p><strong>Email:</strong> {entrepreneur.csp.email}</p>
                  <p><strong>Phone:</strong> {entrepreneur.csp.phone}</p>
                  <p><strong>Location:</strong> {entrepreneur.csp.address}, {entrepreneur.csp.country}</p>
                </div>
              )}

              {/* Fund Button */}
              <div className="d-grid mt-4">
                <Button style={{backgroundColor:'#ffc107'}} size="lg" className="py-3"  onClick={() => setShowModal(true)}>
                  <i className="bi bi-heart-fill me-2"></i>
                  Fund This Entrepreneur
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
        <DonationModal
        show={showModal}
        onClose={() => setShowModal(false)}
      // ✅ prop ka naam yeh hi rakho
      />
    </div>
  );
};

export default Profile1;